// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pbZ5","image":"Header_image__NSIUe","name":"Header_name__1VVuC","info":"Header_info__2UZLZ","infoRow":"Header_infoRow__1uiy6"};